import { render, staticRenderFns } from "./personalInfo.vue?vue&type=template&id=756f7964"
import script from "./personalInfo.vue?vue&type=script&lang=js"
export * from "./personalInfo.vue?vue&type=script&lang=js"
import style0 from "./personalInfo.vue?vue&type=style&index=0&id=756f7964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports